module.exports = "../../../../platform/assets/pageMainIcon/industry_danjuweihulei2.svg";